module.exports = "/images/vendor/flag-icon-css/flags/1x1/lv.svg?f3c1274d166407a222fa7326129821b7";